<template>
  <section class="wl-section" id="section_contact" style="background: var(--wl-bg);">
    <div class="container">
      <div class="row g-4 align-items-stretch">
        <div class="col-lg-6 col-12">
          <div class="wl-card p-4 p-md-5 h-100">
            <h2 class="mb-4" style="font-family: 'Montserrat', sans-serif; font-weight: 700; color: var(--wl-navy);">{{ $t("contact.title") }}</h2>
            <div class="contact-info" style="font-family: 'Inter', sans-serif; font-size: 16px; color: var(--wl-text); line-height: 1.8;">
              <p class="d-flex mb-3">
                <i class="bi-geo-alt me-3 mt-1 text-primary"></i>
                <a href="https://goo.gl/maps/Y49yuc6wRG2yyR4JA" target="_blank" class="text-decoration-none text-body">
                  2700 NE 14th Street Causeway, Pompano Beach, FL 33062
                </a>
              </p>
              <p class="d-flex mb-3">
                <i class="bi-envelope me-3 mt-1 text-primary"></i>
                <a href="mailto:patientcare@diversecarenow.com" class="text-decoration-none text-body">
                  patientcare@diversecarenow.com
                </a>
              </p>
              <p class="d-flex mb-3">
                <i class="bi-instagram me-3 mt-1 text-primary"></i>
                <a href="https://www.instagram.com/diversecarenow/?igshid=YmMyMTA2M2Y%3D" target="_blank" class="text-decoration-none text-body">
                  @diversecarenow
                </a>
              </p>
              <p class="d-flex mb-3">
                <i class="bi-telephone me-3 mt-1 text-primary"></i>
                <a href="tel:+17547521888" class="text-decoration-none text-body">{{ $t("contact.Call") }}</a>
              </p>
              <p class="d-flex mb-3 fw-medium">
                {{ $t("contact.AfterHours") }}
              </p>
              <p class="d-flex mb-3">
                <i class="bi-chat-text me-3 mt-1 text-primary"></i>
                <a href="sms:+17547521888" class="text-decoration-none text-body">{{ $t("contact.SMS") }}</a>
              </p>
              <p class="d-flex mb-3">
                <i class="bi-whatsapp me-3 mt-1 text-primary"></i>
                <a href="https://wa.me/17542761746" target="_blank" class="text-decoration-none text-body">{{ $t("contact.WhatsappMsg") }}</a>
              </p>
            </div>
          </div>
        </div>
        
        <div class="col-lg-6 col-12">
          <div class="wl-card p-4 p-md-5 h-100 d-flex flex-column">
            <h2 class="mb-4" style="font-family: 'Montserrat', sans-serif; font-weight: 700; color: var(--wl-navy);">{{ $t("contact.findUs") }}</h2>
            <div class="flex-grow-1" style="min-height: 300px;">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3578.36699232508!2d-80.097983384969!3d26.249750083417524!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xc093858c1cac6fb0!2zMjbCsDE0JzU5LjEiTiA4MMKwMDUnNDQuOSJX!5e0!3m2!1spt-BR!2sbr!4v1672442523357!5m2!1spt-BR!2sbr"
                class="w-100 h-100 rounded"
                style="border: 0;"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              >
              </iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "ContactComponent",
};
</script>
